import './style.scss'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import Button from 'components/UI/Button'
import ButtonRow from 'components/UI/ButtonRow'
import Modal from 'components/UI/Modal'
import { getRegionFromTransportProduct } from 'utilities/region'
import { setSubscriptionRegion } from 'actions/Regions'

class WrongRegionModal extends PureComponent {
    render() {
        const { subscriptionRegion, selectedRegion, onClose, dispatch, t } = this.props
        const regions = {
            subscriptionRegion,
            selectedRegion,
        }

        return (
            <Modal show={true} onClose={onClose}>
                <div className="wrong-region-modal">
                    {t('subscriptionWarningOtherRegionSelected', regions)}
                    <ButtonRow>
                        <Button variant="secondary" onClick={onClose}>
                            {t('subscriptionWrongRegionModalCancel')}
                        </Button>
                        <Button variant="primary" onClick={() => dispatch(setSubscriptionRegion())}>
                            {t('subscriptionWrongRegionModalChangeRegion', regions)}
                        </Button>
                    </ButtonRow>
                </div>
            </Modal>
        )
    }
}

WrongRegionModal.propTypes = {
    subscriptionRegion: PropTypes.string,
    selectedRegion: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

const mapStateToProps = ({ subscription, region }) => ({
    subscriptionRegion: getRegionFromTransportProduct(
        subscription.subscriptionTransportProduct,
        region.regions
    ),
    selectedRegion: getRegionFromTransportProduct(
        subscription.selectedTransportProduct,
        region.regions
    ),
})

export default connect(mapStateToProps)(withTranslation()(WrongRegionModal))
